<template>
	<!--
		LIST_F1 — informação de origem no banco (tecla F10).
		Espelha Consultas/LIST_F1 do Delphi: formulário, controle, tabela, campo.
	-->
	<Dialog
		v-model:visible="visible"
		modal
		:closable="true"
		:draggable="false"
		header="Origem no banco (F10)"
		class="field-db-info-dialog"
		:style="{ width: 'min(92vw, 26rem)' }"
		@hide="hideFieldDbInfo"
	>
		<div v-if="info" class="field-db-info">
			<div class="field-db-info__row">
				<span class="field-db-info__label">Formulário</span>
				<span class="field-db-info__value">{{ info.formulario || "—" }}</span>
			</div>
			<div class="field-db-info__row">
				<span class="field-db-info__label">Controle</span>
				<span class="field-db-info__value">{{ info.controle || "—" }}</span>
			</div>
			<div v-if="info.label" class="field-db-info__row">
				<span class="field-db-info__label">Rótulo</span>
				<span class="field-db-info__value">{{ info.label }}</span>
			</div>
			<div class="field-db-info__row field-db-info__row--destaque">
				<span class="field-db-info__label">Tabela</span>
				<span class="field-db-info__value field-db-info__mono">{{ info.tabela }}</span>
				<button
					type="button"
					class="field-db-info__copy"
					title="Copiar tabela"
					@click="copiar(info.tabela)"
				>
					<i class="pi pi-copy" />
				</button>
			</div>
			<div class="field-db-info__row field-db-info__row--destaque">
				<span class="field-db-info__label">Campo</span>
				<span class="field-db-info__value field-db-info__mono">{{ info.campo }}</span>
				<button
					type="button"
					class="field-db-info__copy"
					title="Copiar campo"
					@click="copiar(info.campo)"
				>
					<i class="pi pi-copy" />
				</button>
			</div>
			<div class="field-db-info__row field-db-info__row--destaque">
				<span class="field-db-info__label">Origem</span>
				<span class="field-db-info__value field-db-info__mono">
					{{ origemCompleta }}
				</span>
				<button
					type="button"
					class="field-db-info__copy"
					title="Copiar TABELA.CAMPO"
					@click="copiar(origemCompleta)"
				>
					<i class="pi pi-copy" />
				</button>
			</div>
			<div v-if="info.observacao" class="field-db-info__row">
				<span class="field-db-info__label">Obs.</span>
				<span class="field-db-info__value">{{ info.observacao }}</span>
			</div>
			<div v-if="info.valorAtual != null && info.valorAtual !== ''" class="field-db-info__row">
				<span class="field-db-info__label">Valor</span>
				<span class="field-db-info__value field-db-info__mono">{{ info.valorAtual }}</span>
			</div>
			<p v-if="copiado" class="field-db-info__feedback">Copiado.</p>
		</div>

		<template #footer>
			<Button label="OK" icon="pi pi-check" autofocus @click="hideFieldDbInfo" />
		</template>
	</Dialog>
</template>

<script lang="ts" setup>
	import { computed, ref } from "vue";
	import { useFieldDbInfo } from "~/composables/useFieldDbInfo";

	const { visible, info, hideFieldDbInfo } = useFieldDbInfo();
	const copiado = ref(false);

	const origemCompleta = computed(() => {
		if (!info.value) return "—";
		const t = info.value.tabela || "—";
		const c = info.value.campo || "—";
		return `${t}.${c}`;
	});

	async function copiar(texto: string) {
		try {
			await navigator.clipboard.writeText(texto);
			copiado.value = true;
			setTimeout(() => {
				copiado.value = false;
			}, 1500);
		} catch {
			// fallback silencioso
		}
	}
</script>

<style scoped>
	.field-db-info {
		display: flex;
		flex-direction: column;
		gap: 0.55rem;
		font-size: 0.92rem;
	}

	.field-db-info__row {
		display: grid;
		grid-template-columns: 6.5rem 1fr auto;
		align-items: start;
		gap: 0.4rem 0.6rem;
	}

	.field-db-info__row--destaque .field-db-info__value {
		font-weight: 600;
		color: #05507f;
	}

	.field-db-info__label {
		font-weight: 700;
		color: #495057;
		text-align: right;
		padding-top: 0.1rem;
	}

	.field-db-info__value {
		word-break: break-word;
		min-width: 0;
	}

	.field-db-info__mono {
		font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
		font-size: 0.88rem;
	}

	.field-db-info__copy {
		border: none;
		background: transparent;
		color: #6c757d;
		cursor: pointer;
		padding: 0.15rem 0.35rem;
		border-radius: 4px;
		line-height: 1;
	}

	.field-db-info__copy:hover {
		background: #e9ecef;
		color: #05507f;
	}

	.field-db-info__feedback {
		margin: 0.25rem 0 0;
		font-size: 0.8rem;
		color: #0f8c50;
		text-align: right;
	}
</style>

<style>
	.field-db-info-dialog.p-dialog {
		box-shadow: var(--harpia-shadow-md, 0 8px 20px rgba(15, 23, 42, 0.08));
	}
</style>
